'use client'

import { AppErrorFallback } from '@/shared/ui'

import { pretendard } from './fonts'

import './globals.css'

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return (
    <html lang='ko' className={pretendard.className}>
      <body className='antialiased'>
        <AppErrorFallback
          error={error}
          reset={reset}
          componentName='GlobalError'
        />
      </body>
    </html>
  )
}
